import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onBeforeUnmount, onMounted } from 'vue'

// ResizeObserverはChromeにしか対応していない為、polyfillを利用する
import ResizeObserver from 'resize-observer-polyfill'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResizeBox',
  emits: ["resize"],
  setup(__props, { emit }: { emit: ({
  (e: 'resize'): void
}), expose: any, slots: any, attrs: any }) {

let resizeObserver: ResizeObserver | null = null
const elements = ref<HTMLElement[]>([])



const handleResize = () => {
  emit('resize')
}

onMounted(() => {
  const sideNav = document.getElementById('sidenav')

  // windowにしたかったが、domじゃないとerrorになる為bodyで代用
  elements.value.push(document.body)

  // サイドナビを開閉時にリサイズイベントを発生させたい為
  if (sideNav) {
    // サイドナビが無いページもあるので分岐
    elements.value.push(sideNav)
  }

  resizeObserver = new ResizeObserver(() => {
    handleResize()
  })

  for (const element of elements.value) {
    resizeObserver.observe(element)
  }
})

onBeforeUnmount(() => {
  // resizeObserverを削除
  if (resizeObserver) {
    for (const element of elements.value) {
      resizeObserver.unobserve(element)
      resizeObserver.disconnect()
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})